var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 3.75C9.60063 3.75 7.25013 6.1005 7.25013 9C7.25013 11.8995 9.60063 14.25 12.5001 14.25C15.3996 14.25 17.7501 11.8995 17.7501 9C17.7501 6.1005 15.3996 3.75 12.5001 3.75ZM5.75013 9C5.75013 5.27208 8.7722 2.25 12.5001 2.25C16.228 2.25 19.2501 5.27208 19.2501 9C19.2501 12.7279 16.228 15.75 12.5001 15.75C8.7722 15.75 5.75013 12.7279 5.75013 9Z",
    fill: "#4C576C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 15.7492C10.7885 15.7492 9.10702 16.1998 7.62474 17.0557C6.14246 17.9115 4.91161 19.1426 4.05593 20.625C3.84886 20.9837 3.39017 21.1066 3.03144 20.8996C2.6727 20.6925 2.54975 20.2338 2.75682 19.8751C3.74415 18.1646 5.16435 16.7442 6.87468 15.7566C8.585 14.7691 10.5252 14.2492 12.5001 14.2492C14.4751 14.2492 16.4153 14.7691 18.1256 15.7566C19.8359 16.7442 21.2561 18.1646 22.2434 19.8751C22.4505 20.2338 22.3276 20.6925 21.9688 20.8996C21.6101 21.1066 21.1514 20.9837 20.9443 20.625C20.0886 19.1426 18.8578 17.9115 17.3755 17.0557C15.8932 16.1998 14.2118 15.7492 12.5001 15.7492Z",
    fill: "#4C576C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerIcon);
export default __webpack_public_path__ + "static/media/consumer-icon.100d27c7cab40186c1c1e52e3856e779.svg";
export { ForwardRef as ReactComponent };